<script setup lang="ts">
defineProps<{
    payload: { text: string };
}>();
</script>

<template>
  <p class="text-sm whitespace-pre-wrap leading-relaxed">
    {{ payload.text }}
  </p>
</template>
